import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  padding: 0;

  @media (max-width: 900px) {
    overflow-x: hidden;
    width: 100vw;
    height: 100vh;
  }

  main {
    height: 100%;
    width: 100%;
    background-image: ${({ theme }) => theme.background};
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
      rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;

    @media (max-width: 700px) and (min-height: 500px) {
      flex-direction: column;
    }

    @media (max-width: 997px) {
      box-shadow: none;

      span {
        max-width: 300px;
      }
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  background-color: ${({ theme }) => theme.background};

  @media (min-width: 996px) {
    > p {
      display: none;
    }
  }

  @media (max-width: 996px) {
    margin-top: 2rem;
    width: 100vw;

    > p {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      width: 100%;
      color: #fff;
      margin-top: auto;

      svg {
        margin-left: 8px;
        transform: rotateX(180deg);
      }
    }
  }
`;

export const GameContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;

  max-width: calc(100vw - 21vw);

  > span {
    width: 100%;
    display: flex;
    background: linear-gradient(
      90deg,
      rgba(127, 71, 136, 1) 10%,
      rgba(84, 173, 72, 1) 50%,
      rgba(84, 173, 72, 1) 100%
    );

    justify-content: space-around;

    p {
      font-size: 2rem;
      height: 4.25rem;
      font-weight: bold;
      letter-spacing: 1px;
      color: #fff;
      display: flex;
      align-items: center;
      margin: 0;

      svg {
        margin-right: 8px;
      }
    }

    p:last-child {
      img {
        margin-right: 12px;
        width: 2.25rem;
      }
    }
  }

  @media (max-width: 996px) {
    > span {
      display: none;
    }
  }

  div {
    display: flex;

    main {
      padding: 0 2rem;
      section {
        display: flex;

        img {
          height: 400px;

          @media (max-width: 1280px) {
            height: 350px;
          }
        }

        span {
          display: flex;
          align-items: center;
          margin: 0 1.5rem;

          h3 {
            color: ${({ theme }) => theme.text};
            font-size: 4rem;
            line-height: 6rem;
          }
        }

        @media (max-width: 1500px) {
          span {
            h3 {
              font-size: 3rem;
              line-height: 4.5rem;
            }
          }
        }

        @media (max-width: 1200px) {
          span {
            h3 {
              font-size: 2.5rem;
            }
          }
          img {
            height: 300px;
          }
        }

        @media (max-width: 996px) {
          span {
            h3 {
              font-size: 2rem;
              line-height: 3.25rem;
            }
          }
          img {
            height: 200px;
          }
        }

        @media (max-width: 430px) {
          span {
            margin: 0 0.75rem;
            h3 {
              font-size: 1.5rem;
              line-height: 2.75rem;
            }
          }
          img {
            height: 150px;
          }
        }

        @media (max-width: 368px) {
          span {
            h3 {
              flex: 1;
              font-size: 1rem;
              line-height: 1.25rem;
            }
          }
          img {
            height: 100px;
          }
        }
      }
    }
  }
  @media (max-width: 996px) {
    div {
      flex-direction: column;
    }
  }

  @media (min-width: 997px) {
    &::before {
      content: '';
      width: 100%;
      height: 1.25rem;
      background: #9fa7f7;
    }
  }

  @media (max-width: 996px) {
    margin-top: 1rem;
  }
`;
